<template>
  <!-- hour labels above a DayTimelineTrack; place both in columns of the same width -->
  <div class="relative h-full">
    <span
      v-for="hour in AXIS_HOURS"
      :key="hour"
      class="absolute bottom-1.25 -translate-x-1/2 font-mono text-unit text-muted"
      :style="{ left: dayPercent(hour * 60) }"
    >{{ String(hour).padStart(2, '0') }}</span>
    <span
      v-if="now"
      class="absolute top-1 -translate-x-1/2 text-unit font-bold whitespace-nowrap text-accent"
      :style="{ left: dayPercent(minutesOfDay(now)) }"
    >{{ t('reports.now') }}</span>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { AXIS_HOURS, dayPercent, minutesOfDay } from '@/utils/dayTimeline';

defineProps({
  // marks the current time; leave empty for a day other than today
  now: [String, Object],
});

const { t } = useI18n();
</script>
